import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Gallery() {
  const images = [{
    url: 'https://cdn.magicpatterns.com/uploads/7hTSdRr5pGsHguYZbPEASj/Empanadas-de-pollo-im.jpg',
    alt: 'Empanadas'
  }, {
    url: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&q=80&w=1200',
    alt: 'Pizza'
  }, {
    url: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&q=80&w=1200',
    alt: 'Pan'
  }, {
    url: 'https://images.unsplash.com/photo-1509365465985-25d11c17e812?auto=format&fit=crop&q=80&w=1200',
    alt: 'Facturas'
  }, {
    url: 'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?auto=format&fit=crop&q=80&w=1200',
    alt: 'Pastas'
  }, {
    url: 'https://images.unsplash.com/photo-1551024506-0bccd828d307?auto=format&fit=crop&q=80&w=1200',
    alt: 'Postres'
  }, {
    url: 'https://images.unsplash.com/photo-1621939514649-280e2ee25f60?auto=format&fit=crop&q=80&w=1200',
    alt: 'Snacks'
  }, {
    url: 'https://images.unsplash.com/photo-1576092768241-dec231879fc3?auto=format&fit=crop&q=80&w=1200',
    alt: 'Mate'
  }, {
    url: 'https://images.unsplash.com/photo-1610832958506-aa56368176cf?auto=format&fit=crop&q=80&w=1200',
    alt: 'Frutas'
  }];
  return <section className="py-20 md:py-32 bg-gray-900 overflow-hidden" data-id="element-41">
      <div className="max-w-7xl mx-auto px-6 mb-12 text-center" data-id="element-42">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-serif font-black text-white tracking-tight" data-id="element-43">
          IMAGINÁ VOLVER A COMER <span className="text-accent" data-id="element-44">TODO ESTO</span>
        </motion.h2>
      </div>

      {/* Auto-scrolling gallery effect using framer motion or simple CSS */}
      <div className="flex overflow-x-auto hide-scrollbar gap-6 px-6 pb-12 snap-x snap-mandatory" data-id="element-45">
        {images.map((img, index) => <motion.div key={index} initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="min-w-[85vw] md:min-w-[600px] aspect-[4/3] rounded-[2rem] overflow-hidden shadow-2xl snap-center relative group" data-id="element-46">
            <img src={img.url} alt={img.alt} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-47" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-8 md:p-12" data-id="element-48">
              <span className="text-white font-serif text-3xl md:text-5xl font-bold tracking-wide" data-id="element-49">
                {img.alt}
              </span>
            </div>
          </motion.div>)}
      </div>

      <div className="text-center mt-8 px-6" data-id="element-50">
        <Button data-id="element-51">QUIERO VOLVER A DISFRUTAR LA COMIDA</Button>
      </div>
    </section>;
}